import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

import {
  de_common,
  de_footer,
  de_terms,
  de_privacy,
  de_notice,
  de_about,
  de_b2b,
  de_contact,
  de_main,
  de_faqs,
  de_pageNotFound,
  de_login,
  de_shop,
  de_productPage,
} from "./locale/de"

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        common: de_common,
        footer: de_footer,
        terms: de_terms,
        privacy: de_privacy,
        notice: de_notice,
        about: de_about,
        b2b: de_b2b,
        contact: de_contact,
        main: de_main,
        faqs: de_faqs,
        pageNotFound: de_pageNotFound,
        login: de_login,
        shop: de_shop,
        productPage: de_productPage,
      }
    },
    fallbackLng: "de",
    supportedLngs: ["de", "en"],
    backend: {
      loadPath: "./locale/{{lng}}/{{ns}}.json",
      addPath: "./locale/{{lng}}/{{ns}}.missing.json",
    },
    saveMissing: true,
    saveMissingTo: "all",
    ns: ["common", "header", "footer"],
    defaultNS: "common",
    missingKeyHandler: (lng, ns, key) => {
      console.warn(`Error at key: ${key} in Namespace: ${ns} and language: ${lng}`);
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator"],
      caches: ["cookie"],
    },
    debug: false,
  });

export default i18n;